import { createSelector } from '@reduxjs/toolkit'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectFinancialCockpitDownload = createSelector(
  selectFinancialCockpitState,
  (state) => state.download
)
